import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const siteUrl = 'https://niia.com.ua'

const pages = {
  '/': {
    title: 'Салон краси Нія у Зінькові',
    description: 'Салон краси «Нія» у Зінькові: перукарські послуги, манікюр, педикюр і професійний макіяж.',
  },
  '/about': {
    title: 'Про салон — Салон краси Нія',
    description: 'Дізнайтеся більше про салон краси «Нія», нашу команду, сервіс і турботу про клієнтів.',
  },
  '/services': {
    title: 'Послуги — Салон краси Нія',
    description: 'Перукарські послуги, манікюр, педикюр і професійний макіяж у салоні краси «Нія» в Зінькові.',
  },
  '/contacts': {
    title: 'Контакти — Салон краси Нія',
    description: 'Адреса, телефони та графік роботи салону краси «Нія» в Зінькові.',
  },
}

const notFoundPage = {
  title: 'Сторінку не знайдено — Салон краси Нія',
  description: 'Запитаної сторінки не існує або її було переміщено.',
}

const Seo = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    const pageExists = Boolean(pages[pathname])
    const page = pages[pathname] || notFoundPage
    const canonicalPath = pageExists ? pathname : '/'
    const canonical = document.querySelector('link[rel="canonical"]')
    const description = document.querySelector('meta[name="description"]')
    let robots = document.querySelector('meta[name="robots"]')
    const openGraphTitle = document.querySelector('meta[property="og:title"]')
    const openGraphDescription = document.querySelector('meta[property="og:description"]')
    const openGraphUrl = document.querySelector('meta[property="og:url"]')

    document.title = page.title
    canonical?.setAttribute('href', `${siteUrl}${canonicalPath}`)
    description?.setAttribute('content', page.description)
    openGraphTitle?.setAttribute('content', page.title)
    openGraphDescription?.setAttribute('content', page.description)
    openGraphUrl?.setAttribute('content', `${siteUrl}${canonicalPath}`)

    if (!robots) {
      robots = document.createElement('meta')
      robots.setAttribute('name', 'robots')
      document.head.appendChild(robots)
    }

    robots.setAttribute('content', pageExists ? 'index, follow' : 'noindex, follow')
  }, [pathname])

  return null
}

export default Seo
